<template>
    <v-expansion-panels v-if="contact_possibilities.length > 0" class="mb-5">
        <v-expansion-panel class="expansion-box">
            <v-expansion-panel-header>
                <span class="font-weight-bold" v-html="$th('profile.contact')"></span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <div v-for="(contact, index) in contact_possibilities" :key="index" class="mb-2">
                    <div class="mb-2 font-weight-bold">
                        {{contact.description}}
                    </div>
                    <div class="mb-2">
                        <template v-for="(segment, segment_index) in split_text_into_segments(contact.text)">
                            <a v-if="segment.is_url"
                               :key="segment_index"
                               :href="segment.text"
                               class="contact-link"
                               target="_blank"
                               rel="noopener noreferrer nofollow ugc">{{segment.text}}</a>
                            <span v-else :key="segment_index">{{segment.text}}</span>
                        </template>
                    </div>
                    <v-divider v-if="index !== contact_possibilities.length-1"></v-divider>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    export default {
        props  : ['contact_possibilities'],
        methods: {
            // Splits a text into plain text and url segments so that urls can be rendered as links.
            // Only http and https urls are matched, which keeps javascript: and data: urls out of the href binding.
            // The segments are rendered by the template as text nodes, so user input is never interpreted as HTML.
            split_text_into_segments(text) {
                const source    = typeof text === "string" ? text : "";
                const url_regex = /https?:\/\/[^\s<>"']+/gi;
                const segments  = [];
                let last_index  = 0;
                let match;

                while ((match = url_regex.exec(source)) !== null) {
                    // Trailing punctuation belongs to the sentence, not to the url
                    let url = match[0].replace(/[.,;:!?]+$/, "");

                    // Closing brackets only belong to the url as long as there is an opening bracket for each of them
                    while (url.endsWith(")") && url.split(")").length > url.split("(").length)
                        url = url.slice(0, -1);

                    if (match.index > last_index)
                        segments.push({text: source.slice(last_index, match.index), is_url: false});

                    segments.push({text: url, is_url: true});
                    last_index = match.index + url.length;
                    url_regex.lastIndex = last_index;
                }

                if (last_index < source.length)
                    segments.push({text: source.slice(last_index), is_url: false});

                return segments;
            },
        },
    }
</script>

<style scoped>
    /* The global stylesheet resets the color of all links, so the color needs a higher specificity to win */
    .v-application a.contact-link {
        color         : #64b5f6 !important;
        text-decoration: underline;
        overflow-wrap : anywhere;
    }
</style>
